import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';
import { useCallback } from 'react';

type DeleteDomainConfirmationModalProps = CommonTemplateProps & {
  readonly isLoading: boolean;
  readonly onConfirm: () => void;
};

export const DeleteDomainConfirmationModal = ({
  closeModal,
  isLoading,
  isOpen,
  modalName,
  onConfirm,
}: DeleteDomainConfirmationModalProps) => {
  const handleClose = () => {
    closeModal();
  };

  const { track } = useAnalytics();
  const handleOnConfirm = useCallback(() => {
    track('modal', {
      action: 'tapped',
      cta: 'primary',
      modal_name: modalName,
    });
    onConfirm();
    closeModal();
  }, [closeModal, modalName, onConfirm, track]);

  const handleOnCancel = useCallback(() => {
    track('modal', {
      action: 'tapped',
      cta: 'secondary',
      modal_name: modalName,
    });
    closeModal();
  }, [closeModal, modalName, track]);

  return (
    <ModalTemplateWrapper
      ariaLabel="delete-domain-confirmation-modal"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleOnConfirm,
          isLoading,
          label: 'Delete',
          variant: 'V2Primary',
        },
        secondaryCTA: {
          handleOnClick: handleOnCancel,
          label: 'Never mind',
          variant: 'V2TertiaryOutline',
        },
      }}
      desktopModalSize="md"
      headerText="Delete this domain?"
      isOpen={isOpen}
      onClose={handleClose}
      subheaderText="This can't be undone."
    />
  );
};
